window.Vue = require('vue');
import './functions';

import ClickOutside from 'vue-click-outside';
import { VTooltip } from 'v-tooltip';
import sort from './components/sort';
import forms from './components/forms';
import avatar from './components/avatar';
import cardmenu from './components/card-menu';
import cardDropdown from './components/card-dropdown';
import cardButton from './components/card-button';
import question from './components/question';
import inputNumber from './components/inputNumber';
import inputDatePicker from './components/inputDatePicker';
import inputLocation from './components/inputLocation';
import inputSearch from './components/inputSearch';
import inputGroup from './components/inputGroup';
import inputRating from './components/inputRating';
import chartSerial from './components/chartSerial';
import chartProgress from './components/chartProgress';
import uploadButton from "./components/uploadButton";
import inputTags from './components/inputTags';
import navigationTabs from './components/navigationTabs';
import navigationDropdown from './components/navigationDropdown';
import timeline from './components/timeline';
import notes from './components/notes';
import vote from './components/vote';
import beanButton from './components/buttonBean';
import switchButton from './components/buttonSwitch';
import confirmButton from './components/buttonConfirm';
import toggleButton from './components/buttonToggle';
import statusMessage from './components/statusMessage';
import plaid from './components/billing/plaid';
import stripe from './components/billing/stripe';
import sms from './components/sms';
import share from './components/share';

Vue.directive('tooltip', VTooltip);
Vue.directive('ClickOutside',ClickOutside);

Vue.component('sort',sort);
Vue.component('question',question);
Vue.component('inputNumber',inputNumber);
Vue.component('inputDatePicker',inputDatePicker);
Vue.component('inputLocation',inputLocation);
Vue.component('inputSearch',inputSearch);
Vue.component('inputGroup', inputGroup);
Vue.component('inputRating', inputRating);
Vue.component('avatar',avatar);
Vue.component('forms',forms);
Vue.component('inputTags',inputTags);
Vue.component('timeline',timeline);
Vue.component('notes',notes);
Vue.component('vote',vote);
Vue.component('beanButton',beanButton);
Vue.component('toggleButton',toggleButton);
Vue.component('confirmButton',confirmButton);
Vue.component('switchButton',switchButton);
Vue.component('cardDropdown',cardDropdown);
Vue.component('cardButton',cardButton);
Vue.component('navigationDropdown',navigationDropdown);
Vue.component('navigationTabs',navigationTabs);
Vue.component('statusMessage',statusMessage);
Vue.component('plaid',plaid);
Vue.component('uploadButton',uploadButton);
Vue.component('sms',sms);
Vue.component('share',share);


const app = new Vue({
    el: '#app',
    components: {
        forms,
        avatar,
        cardmenu,
        question,
        inputNumber,
        inputDatePicker,
        inputLocation,
        inputSearch,
        inputRating,
        inputGroup,
        chartSerial,
        chartProgress,
        navigationTabs,
        timeline,
        navigationDropdown,
        notes,
        vote,
        beanButton,
        confirmButton,
        switchButton,
        toggleButton,
        cardDropdown,
        cardButton,
        sort,
        statusMessage,
        plaid,
        stripe,
        uploadButton,
        sms
    },
    data: {
        user_id:false,
        first_name:false,
        last_name:false,
        avatar:false,
        refresh:0,
        project: {
            hours:0,
            billable:0,
            days:0
        },
        projectInterval:false,
        projectBillable:0,
        projectChartData:{},
        projectBeans:[],
        projectBeanIDs:[],
        projectBeanCount:1,
        removeProjectBean:function(index) {
            this.projectBeans.splice(index,1);
            this.projectBeanIDs.splice(index,1);
        },
        name:function() {
            return this.first_name + ' ' + this.last_name;
        },
        mobileMenu: {
            isOpen:false,
            toggle:function() {
                app.mobileMenu.isOpen = app.mobileMenu.isOpen ? false : true;
            }
        },
        modal: {
            isOpen:false,
            isLoading:false,
            content:false,
            open:function(url) {
                if(url) {
                    var e = this;
                    var $modal = $('#modal');
                    this.isLoading = true;
                    app.mobileMenu.isOpen = false;
                    app.modal.isOpen = true;
                    if (!$modal.is(':visible')) {
                        $modal.find('.modal-bg').hide();
                    }
                    $modal.find('.modal-content').hide();
                    $modal.show();
                    $modal.find('.modal-bg').fadeIn(function () {
                        $modal.find('.modal-content').css('opacity', 0).show();
                        $modal.find('.modal-content').animate({opacity: 1}, 350);
                    });
                    $.get(url,function(data) {
                       if(data.status == 200) {
                           $('#modal-render').html('<div id="modal-render-content"></div>');
                           var res = Vue.compile(data.content)
                           var vm = new Vue({
                               el:'#modal-render-content',
                               render: res.render,
                               staticRenderFns: res.staticRenderFns
                           });
                           e.isLoading = false;
                           app.modal.position();
                       } else {
                           if(data.status == 401) {
                               document.location.href = document.location.href;
                           } else {
                               alert(data.msg);
                           }
                       }
                    });
                }
            },
            position:function() {
                var $modal = $('#modal');
                if(parseFloat($modal.find('.modal-wrap').css('height')) + 70 > $(window).height()) {
                    $modal.addClass('position-top');
                    $modal.animate({ scrollTop:0},250);
                } else {
                    $modal.removeClass('position-top');
                }
            },
            close:function() {
                app.modal.isOpen = false;
                $('.modal').fadeOut();
            }
        },
        form: {
            submitting:false,
            destroy:function(url) {
                if(!this.submitting) {
                    this.submitting = true;
                    var e = this;
                    var $target = $(event.target);
                    var currentMessage = $target.html();
                    $.ajax({
                        url: url,
                        type: "DELETE",
                        success: function (response) {
                            $target.html(response.msg);
                            setTimeout(function () {
                                if(response.location != undefined) {
                                    document.location.href = response.location;
                                } else {
                                    $target.html(currentMessage);
                                    e.submitting = false;
                                }
                            }, 1000);
                        }
                    });
                }
            }
        },
        drawer:{
            isOpen:false,
            isLoading:false,
            open:function(url) {
                var alreadyOpen = app.drawer.isOpen;
                if(alreadyOpen) {
                    $('#drawer #drawer-render').css('opacity',0);
                    $('#drawer .drawer-wrap').scrollTop(0);
                }
                app.drawer.isOpen = true;
                if(url) {
                    var e = this;
                    var $drawer = $('#drawer');
                    e.isLoading = true;
                    $('#drawer-render').html('');
                    $.get(url,function(data) {
                        if(alreadyOpen) {
                            $('#drawer #drawer-render').animate({ opacity:1 },500);
                        }
                        if(data.status == 200) {
                            $('#drawer-render').html('<div id="drawer-render-content"></div>');
                            var res = Vue.compile(data.content)
                            var vm = new Vue({
                                el:'#drawer-render-content',
                                render: res.render,
                                staticRenderFns: res.staticRenderFns
                            });
                            e.isLoading = false;
                        } else {
                            if(data.status == 401) {
                                document.location.href = document.location.href;
                            } else {
                                alert(data.msg);
                            }
                        }
                    });
                }
            },
            close:function() {
                app.drawer.isOpen = false;
            }
        },
        bottomDrawer: {
            isOpen:false,
            isLoading:false,
            lastEndpoint:false,
            lastTitle:false,
            title:'',
            open:function(url,title) {
                app.bottomDrawer.lastEndpoint = url;
                app.bottomDrawer.lastTitle = title;
                app.bottomDrawer.isOpen = true;
                app.bottomDrawer.isLoading = true;
                app.bottomDrawer.title = title != undefined ? title : '';
                $('#bottom-drawer-render').html('<div id="bottom-drawer-render-content"></div>');
                $.get(url,function(data) {
                    if(data.status == 200) {
                       setTimeout(function() {
                           var res = Vue.compile('<div class="fade-in">'+data.content+'</div>');
                           var vm = new Vue({
                               el:'#bottom-drawer-render-content',
                               render: res.render,
                               staticRenderFns: res.staticRenderFns
                           });
                           app.bottomDrawer.isLoading = false;
                       },400);

                    } else {
                        if(data.status == 401) {
                            document.location.href = document.location.href;
                        } else {
                            alert(data.msg);
                        }
                    }
                });
            },
            close:function() {
                app.bottomDrawer.isOpen = false;
                $('#bottom-drawer-render .floating-button').remove();
                $('#bottom-drawer-render .floating-action').remove();
            },
            refresh:function() {
                if(app.bottomDrawer.isOpen && app.bottomDrawer.lastEndpoint){
                    app.bottomDrawer.open(app.bottomDrawer.lastEndpoint,app.bottomDrawer.lastTitle);
                }
            }
        }
    },
    methods: {
        animateProjectNumbers(from,to) {
            var billableFrom = Number(from.billable.replace(/[^0-9\.]+/g,""));
            var billableTo = Number(to.billable.replace(/[^0-9\.]+/g,""));
            var hoursFrom = Number(from.hours);
            var hoursTo = to.hours;
            this.project.billable = '$' + this.formatNumber(billableFrom.toFixed(0));
            this.project.hours = Number(hoursFrom);
            if(billableTo != billableFrom) {
                var greater = billableTo > billableFrom ? true : false;
                var intervalSteps = 1;
                var intervalHourSteps = 0.5;
                if(greater) {
                    intervalSteps = Math.floor((billableTo - billableFrom) / 20);
                    intervalHourSteps = (hoursTo - hoursFrom) / 20;
                } else {
                    intervalSteps = Math.floor((billableFrom - billableTo) / 20);
                    intervalHourSteps = (hoursFrom - hoursTo) / 20;
                }
                this.projectInterval = setInterval(function() {
                    if(billableTo != billableFrom) {
                        if(hoursFrom != hoursTo) {
                            if(greater) {
                                hoursFrom += intervalHourSteps;
                                if(hoursFrom > hoursTo) {
                                    hoursFrom = hoursTo;
                                }
                            } else {
                                hoursFrom -= intervalHourSteps;
                                if(hoursFrom < hoursTo) {
                                    hoursFrom = hoursTo;
                                }
                            }
                        }
                        if (greater) {
                            billableFrom += intervalSteps;
                            if(billableFrom > billableTo) {
                                billableFrom = billableTo;
                            }
                        } else {
                            billableFrom -= intervalSteps;
                            if(billableFrom < billableTo) {
                                billableFrom = billableTo;
                            }
                        }
                        this.project.billable = '$' + this.formatNumber(billableFrom.toFixed(0));
                        this.project.hours = hoursFrom.toFixed(2);
                    } else {
                        clearInterval(this.projectInterval);
                        this.project.hours = hoursTo;
                    }
                }.bind(this),20);
            }
        },
        formatNumber:function(num) {
            return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        }
    },
    beforeMount:function() {
        var e = this;
        $.each(['project.hours','project.billable','project.days'],function(_,value) {
            if($('[data-bind=\'' + value + '\']').length > 0) {
                var newValue = $('[data-bind=\'' + value + '\']').html();
                switch(value) {
                    case('project.hours'):
                        e.project.hours = newValue;
                        break;
                    case('project.billable'):
                        e.project.billable = newValue;
                        e.projectBillable = newValue;
                        break;
                    case('project.days'):
                        e.project.days = newValue;
                        break;
                }
            }
        });
        if($(e.$el).find('[data-projectData]').length > 0) {
            var newDataProvider = JSON.parse($(e.$el).find('[data-projectData]').attr('data-projectData'));
            this.projectChartData = newDataProvider;
        }
    },
    watch: {
        project:function(newValue,oldvalue) {
            newValue.billable = String(newValue.billable);
            //this.projectBillable = newValue.billable;
            this.animateProjectNumbers(oldvalue,newValue);
        }
    },
    mounted: function(){
        if($("meta[name='user-id']").length > 0) {
            this.user_id = document.querySelector("meta[name='user-id']").getAttribute('content');
            this.first_name = document.querySelector("meta[name='user-first-name']").getAttribute('content');
            this.last_name = document.querySelector("meta[name='user-last-name']").getAttribute('content');
            this.avatar = document.querySelector("meta[name='user-avatar']").getAttribute('content');
        }
        if($("meta[name='project-bean-count']").length > 0) {
            this.projectBeanCount = parseInt($("meta[name='project-bean-count']").attr('content'));
        }
        $(".date-mask").mask("99/99/9999",{placeholder:"MM/DD/YYYY"});
        $(".phone-mask").mask("(999) 999-9999");
        if($('.modal.trigger-open').length > 0) {
            var $modal = $('.modal.trigger-open');
            $(window).on('load',function() {
                $modal.find('.modal-content').hide();
                $modal.find('.modal-bg').hide();
                $modal.show();
                $modal.find('.modal-bg').fadeIn(function () {
                    $modal.find('.modal-content').css('opacity', 0).show();
                    $modal.find('.modal-content').animate({opacity: 1}, 350);
                });
            });
        }

    }
});

Vue.prototype.$toggleActive = function(isRadio) {
    var e = event.target;
    var $root = this.$root;
    var $label = $(e).closest('label');
    var $container = $(e).closest('.checkbox-grid-container');
    var isOther = false;
    if(isRadio) {
        $container.find('label').removeClass('active');
        $container.find('input').prop('checked',false);
    }
    if($label.hasClass('active') && !isRadio) {
        setTimeout(function() {
            $label.removeClass('active');
            $label.find('input').prop('checked',false);
            if($label.hasClass('is-other')) {
                $container.find('.other-field').val($container.find('.other-field').data('value')).prop('disabled', true).hide();
                $root.$setModalItemHeight();
            }
        },10);
    } else {
        $label.addClass('active');
        setTimeout(function() {
            $label.find('input').prop('checked',true);
        },10);
        if($label.hasClass('is-other')) {
            if($container.find('.other-field').is(':hidden')) {
                $container.find('.other-field').val($container.find('.other-field').data('value')).prop('disabled', false).show();
            }
            $root.$setModalItemHeight();
            setTimeout(function() {
                $container.find('.other-field').focus();
            },10);
            isOther = true;
        } else if(isRadio) {
            $container.find('.other-field').val($container.find('.other-field').data('value')).prop('disabled', true).hide();
            $root.$setModalItemHeight();
        }
    }

    if(isRadio && !$('.next-button').hasClass('can-submit') && !isOther) {
        setTimeout(function() {
            //$('.next-button').click();
        },100);
    }

};

Vue.prototype.$setModalItemHeight =  function() {
    $('.item-container').css('height',  parseFloat($('.item-container .item').css('height')) + 'px');
}

Vue.prototype.$refresh = function() { app.refresh += 1; }

Vue.prototype.$closeDrawer = function() { app.drawer.close(); }
Vue.prototype.$openDrawer = function(url) { app.drawer.open(url); }

Vue.prototype.$closeModal = function() { app.modal.close(); }
Vue.prototype.$openModal = function(url) { app.modal.open(url); }
Vue.prototype.$positionModal = function() { app.modal.position(); }
Vue.prototype.$modalIsOpen = function() {
    return app.modal.isOpen;
}

Vue.prototype.$refreshBottomDrawer = function() { app.bottomDrawer.refresh(); }
Vue.prototype.$openBottomDrawer = function(url,title) { app.bottomDrawer.open(url,title); }

Vue.prototype.$updateProject = function(data) { app.project = data; }
Vue.prototype.$updateProjectData = function(data) {
    var result = JSON.parse(data);
    app.projectChartData = result.chart;
    app.project = result.totals;
}
Vue.prototype.$deleteRecord = function(url) { app.form.destroy(url); }

Vue.prototype.$getProjectBeans = function() { return app.projectBeans; }
Vue.prototype.$removeProjectBean = function(index) { app.removeProjectBean(index); }
Vue.prototype.$setProjectBean = function(bean) {
    if(app.projectBeans.length >= app.projectBeanCount) {
        app.removeProjectBean(0);
    }
    app.projectBeans.push(bean);
    app.projectBeanIDs.push(bean.id);
}
